'use client';
import { objectKeys, isObject } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const clonePalette = (palette)=>{
    const result = _extends({}, palette);
    if (palette) {
        for (const key of objectKeys(palette)){
            result[key] = _extends({}, palette[key]);
            for (const shadeKey of objectKeys(palette[key])){
                const modes = palette[key][shadeKey];
                if (isObject(modes)) {
                    result[key][shadeKey] = _extends({}, modes);
                }
            }
        }
    }
    return result;
};

export { clonePalette };
//# sourceMappingURL=clonePalette.js.map
